/** Local cancellation ownership; never serialized with actions or inherited by peers. */
const owners = new WeakMap<object, () => boolean>();

export function ownAction<T extends object>(action: T, isCurrent: () => boolean): T {
    owners.set(action, isCurrent);
    return action;
}

export function inheritActionOwner<T extends object>(parent: object, action: T): T {
    const owner = owners.get(parent);
    if (owner) owners.set(action, owner);
    return action;
}

export function isActionCurrent(action: object): boolean {
    return owners.get(action)?.() ?? true;
}
